import apiClient from "../../../utilities/apiClient";
import LocalStorage, { SESSION_KEY } from "../../../utilities/localStorage";


export const item = (payload) => {
  const isFormData = payload instanceof FormData;
  return apiClient.post(
    `${apiClient.Urls.item}`,
    payload,
    true,
    isFormData ? "file" : undefined
  );
};

export const getItemById = (id) => {
  return apiClient.get(`${apiClient.Urls.item}/${id}`, "", true);
};

export const updateItem = (id, payload) => {
  const isFormData = payload instanceof FormData;
  return apiClient.put(
    `${apiClient.Urls.item}/${id}`,
    payload,
    true,
    isFormData ? "file" : undefined
  );
};

export const updateItemStatus = (id, payload) => {
  return apiClient.patch(`${apiClient.Urls.item}/${id}/status`, payload, true);
};

export const getHsns = (payload) => {
  return apiClient.get(`${apiClient.Urls.getHsns}?search=${payload}`, "", true);
};

export const getItem = (page, per_page, search) => {
  return apiClient.get(
    `${apiClient.Urls.item_list}?page=${page}&per_page=${per_page}&search=${
      search ? search : ""
    }`,
    "",
    true
  );
};

export const upload_item = (payload) => {
  return apiClient.post(`${apiClient.Urls.item_upload}`, payload, true, "file");
};

export const downloadItemSample = () => {
  return apiClient.get(`${apiClient.Urls.item_sample}`, {}, true, "file");
};

